import SportAndAge from "./sportAndAge";
import { MdEdit } from "react-icons/md";
import Input from "component/ui/Input";
import Switch from "component/ui/Switch";
import MultiSelectWrapper from "component/ui/MultiSelectWrapper";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import {
  VENUE_TYPE,
  sportOptions,
  gameTypeOption,
  genderOptions,
  ageOptions,
  roles,
  PRIMARY_TYPE,
  ageGroup,
} from "helper/constant";
import { PhoneNumber } from "component/ui/PhoneNumber";
import PageHeading from "component/ui/PageHeading";
import SelectField from "component/ui/SelectField";
import KeyMembers from "./keyMembers";
import RadioCardGroup from "component/ui/RadioCardGroup";
import {
  getVenueList,
  getVenueSelectedSportsList,
  updateProfile,
} from "store/slice/profile";
import Button from "component/ui/Button";
import { toast } from "react-toastify";
import { Trash2 } from "lucide-react";
import { getCurrentcoords, validEmail } from "helper/appConstant";
import LocationPicker from "component/ui/LocationPicker";
import { FaPlus } from "react-icons/fa";
import { FiPlus } from "react-icons/fi";
import { deleteProfileImage, sentOtp, userImageUpload } from "store/slice/auth";
import { IoCloseCircleSharp } from "react-icons/io5";
import OtpDialog from "component/dialogs/OtpDialog";
import FullPageLoader from "component/ui/fullPageLoader";
import AutocompleteInput from "component/ui/AutocompleteInput";
import { RiEditCircleFill } from "react-icons/ri";
import { Link } from "react-router-dom";

const ProfileEdit = () => {
  const [selectedPlayer, setSelectedPlayer] = useState(false);
  const { userProfileData, venueSelectedSportsData, vanueList } = useSelector(
    (state) => state.profile
  );
  const { configData } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const keyMember_initital_state = {
    designation: "",
    email: "",
    name: " ",
    roleId: "",
    roleName: "",
    status: "",
  };
  const achievement_initital_state = {
    categorySelector: "",
    title: "",
    issuingOrganization: " ",
    level: "",
    date: null,
    validity: null,
    expiry: false,
    description: "",
    proof: null,
    proofPath: null,
  };
  const [profileData, setProfileData] = useState({
    alternativeEmail: [""],
    alternativeNumber: [
      {
        contactNo: "",
        countryCode: "",
      },
    ],
    keyMember: keyMember_initital_state,
    achievement_initital_state: achievement_initital_state,
  });
  const [selectedSport, setSelectedSport] = useState([]);
  const [isOTPDialogOpen, setIsOTPDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [coords, setCoords] = useState(null);
  const profileRef = useRef();
  // fetch sports list
  useEffect(() => {
    if (venueSelectedSportsData?.length == 0) {
      dispatch(getVenueSelectedSportsList());
    }
    fetchCoords();
  }, []);
  // set profile data
  useEffect(() => {
    if (userProfileData) {
      setProfileData(JSON.parse(JSON.stringify(userProfileData?.data)));
      setProfileData({
        ...JSON.parse(JSON.stringify(userProfileData?.data)),
        alternativeEmail:
          userProfileData?.data?.alternativeEmail?.length > 0
            ? userProfileData?.data?.alternativeEmail
            : [""],
        keyMember:
          userProfileData?.data?.keyMember?.length > 0
            ? userProfileData?.data?.keyMember
            : [keyMember_initital_state],
        socialLink:
          userProfileData?.data?.socialLink?.length > 0
            ? userProfileData?.data?.socialLink
            : [''],
        alternativeNumber: userProfileData?.data?.alternativeNumber?.length > 0
          ? JSON.parse(JSON.stringify(userProfileData?.data?.alternativeNumber))
          : [{
            contactNo: "",
            countryCode: "",
          }],
      });
    }
  }, [userProfileData]);
  useEffect(() => {
    if (profileData) {
      onSportSearch("");
    }
  }, [profileData]);

  //  handle on-change function
  const handleChange = (name, value) => {
    setProfileData((prev) => ({
      ...prev,
      [name]: value,
      [`${name}Error`]: "",
    }));
  };

  // api callng for update prfile
  const handleEditProfile = () => {
    setLoading(true);
    const request = {
      ...profileData,
      venueAmenitiesIds: profileData?.venueAmenities
        ?.flatMap((section) => section.items)
        ?.filter((item) => item.isSelected)
        ?.map((item) => item.key),
      venueStyle: profileData?.venueStyle,
      // typeof profileData?.venueStyle == "string"
      //   ? [profileData?.venueStyle]
      //   : profileData?.venueStyle,
      alternativeEmail: profileData?.alternativeEmail?.filter(
        (email) => email && email.trim() !== ""
      ),

      keyMember: profileData?.keyMember?.filter((obj) =>
        Object.values(obj).every((value) => value)
      ),

      socialLink: profileData?.socialLink?.filter(
        (link) => link && link.trim() !== ""
      ),

      alternativeNumber: profileData?.alternativeNumber?.filter(
        (obj) => Object.values(obj).every((value) => value)
      ),
      ageGroup: profileData?.multiAgeGroup,
    };
    dispatch(updateProfile(request, setLoading));
  };

  const handleSendVerificationCode = () => {
    const request = {
      email: "",
      userIsExist: false,
      countryCode: profileData?.countryCode,
      phoneNumber: profileData?.contactNo,
    };
    dispatch(sentOtp(request, setIsOTPDialogOpen));
  };
  const validateVenueProfile = () => {
    // Venue name
    if (!profileData?.name?.trim()) {
      return "Venue name is required";
    }

    // Registered venue validation
    if (profileData?.areYouRegisteredVenue) {
      if (!profileData?.registeredVenueId?.trim()) {
        return "Registration number is required";
      }
    }

    // Venue type
    if (!profileData?.venueType) {
      return "Venue type is required";
    }

    // Phone number
    if (!profileData?.contactNo) {
      return "Venue phone number is required";
    }

    // Alternate email validation
    if (profileData?.alternativeEmail?.length > 0) {
      for (const email of profileData.alternativeEmail) {
        if (email && !validEmail(email)) {
          return `"${email}" is not a valid alternate email address.`;
        }
      }
    }

    // Venue location
    if (!profileData?.location?.address?.trim()) {
      return "Venue location is required";
    }

    // Primary sports
    if (!profileData?.primarySports?.length) {
      return "Please select at least one primary sport";
    }

    // Age group
    if (!profileData?.multiAgeGroup?.length) {
      return "Please select age group catered";
    }

    // Gender catered
    if (!profileData?.genderServing?.length) {
      return "Please select gender catered";
    }

    return null; // ✅ no validation errors
  };

  const validateClubProfile = (profileData) => {
    // Club name
    if (!profileData?.name?.trim()) {
      return "Club name is required";
    }

    // Registered Club validation
    if (profileData?.areYouRegisteredClub) {
      if (!profileData?.registeredVenueId?.trim()) {
        return "Registration number is required";
      }
    }

    // Venue type
    if (!profileData?.venueType) {
      return "Club type is required";
    }

    // Phone number
    if (!profileData?.contactNo) {
      return "Club phone number is required";
    }

    // Alternate email validation
    if (profileData?.alternativeEmail?.length > 0) {
      for (const email of profileData.alternativeEmail) {
        if (email && !validEmail(email)) {
          return `"${email}" is not a valid alternate email address.`;
        }
      }
    }

    // Venue location
    if (!profileData?.location?.address?.trim()) {
      return "Club location is required";
    }

    // Primary sports
    if (!profileData?.primarySports?.length) {
      return "Please select at least one primary sport";
    }

    // Age group
    if (!profileData?.multiAgeGroup?.length) {
      return "Please select age group catered";
    }

    // Gender catered
    if (!profileData?.genderServing?.length) {
      return "Please select gender catered";
    }

    return null; // ✅ no validation errors
  };

  const handleSubmit = () => {
    // 🔐 Fire validation only for VENUE users
    if (profileData?.userType === roles?.VENUE) {
      const validationError = validateVenueProfile(profileData);
      if (validationError) {
        return toast.error(validationError);
      }
    }

    if (profileData?.userType === roles?.CLUB) {
      const validationError = validateClubProfile(profileData);
      if (validationError) {
        return toast.error(validationError);
      }
    }
    if (userProfileData?.data?.contactNo == profileData?.contactNo) {
      handleEditProfile();
    } else {
      handleSendVerificationCode();
    }
  };
  // handle upload multiple profile
  const handleUploadProfile = async (files) => {
    const remainingPictures = 5 - profileData?.venueImageUrl?.length;
    let file = files;
    if (files?.length > remainingPictures) {
      // Convert the object to an array of [key, value] pairs
      const entries = Object.entries(files);

      // Slice the array to get the first `n` elements
      const slicedEntries = entries.slice(0, remainingPictures);

      // Convert the sliced array back to an object
      file = Object.fromEntries(slicedEntries);
    }
    // Create a new FormData object for file upload
    const formData = new FormData();
    // If file is an array of files (e.g. after slicing), append each file individually
    if (typeof file === "object" && file !== null) {
      Object.entries(file).forEach(([key, value]) => {
        formData.append("file", value);
      });
    } else {
      // If there's a single file, append it directly
      formData.append("file", file);
    }

    try {
      // Dispatch the upload action
      const data = await dispatch(
        userImageUpload(formData, "profileImage", "image")
      );
      if (data?.length > 0) {
        data?.map((item) => {
          let temp = { ...profileData };
          temp.venueImageUrl.push(item?.path);
          temp.venueImageUrlPath.push(item?.fileName);
          setProfileData(temp);
        });
      }
    } catch (error) {
      console.error("Error uploading files:", error);
    }
  };

  const fetchCoords = async () => {
    try {
      const locationData = await getCurrentcoords();
      setCoords(locationData);
    } catch (error) {
      console.error("Error fetching coordinates:", error);
    }
  };

  // Handle input change and filter suggestions
  const onSportSearch = (value) => {
    const data = {
      language: "en",
      page: 1,
      perPage: 100,
      userType: profileData?.userType == roles?.CLUB ? 5 : 3,
      searchQuery: value,
      sportName: profileData?.primarySports,
      latitude: coords?.lat,
      longitude: coords?.lng,
    };

    dispatch(getVenueList(data));
  };

  return (
    <div className="min-h-screen">
      <div className="lg:max-w-5xl w-full mx-auto lg:p-8 p-4">
        {/* loader */}
        {loading && <FullPageLoader />}
        {/* otp diaog */}
        {isOTPDialogOpen && (
          <OtpDialog
            isOTPDialogOpen={isOTPDialogOpen}
            closeDialog={() => setIsOTPDialogOpen(false)}
            isUpdateNumber
            formData={profileData}
            handleResend={handleSendVerificationCode}
            afterValidate={handleEditProfile}
          />
        )}
        {/* Header */}

        <PageHeading
          title={"Edit Profile"}
          Subtitle={"Update your venue information"}
        />

        {/* Profile Form */}
        <div className="space-y-6">
          <div className="bg-white rounded-2xl shadow-lg lg:p-6 p-3 border border-gray-100">
            {profileData?.userType == roles?.CLUB ? (
              <div className="flex justify-center items-center my-3">
                <div style={{ position: "relative" }}>
                  {profileData?.profileImageUrl ? (
                    <div
                      className="cursor-pointer h-24 border"
                      style={{
                        backgroundImage: `url("${profileData?.profileImageUrl}")`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        borderRadius: "50%",
                        width: "100px",
                      }}
                    ></div>
                  ) : (
                    <div
                      className="h-24"
                      style={{
                        background: "#000",
                        borderRadius: "50%",
                        width: "100px",
                      }}
                    >
                      <input
                        ref={profileRef}
                        onChange={(e) => {
                          handleUploadProfile(e.target.files);
                        }}
                        multiple
                        style={{ display: "none" }}
                        type="file"
                        accept="image/*"
                      />
                    </div>
                  )}
                  <RiEditCircleFill
                    style={{
                      position: "absolute",
                      right: "12px",
                      bottom: "4px",
                      cursor: "pointer",
                      color: "rgb(43 172 226 / var(--tw-text-opacity, 1))",
                      fontSize: "20px",
                    }}
                    onClick={() => {
                      profileRef.current?.click();
                    }}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
            <h2 className="md:text-xl text-lg md:font-semibold font-semibold text-gray-800 flex items-center gap-2 md:my-5 my-4">
              <div className="w-1 h-6 bg-[#2bace2] rounded-full"></div>
              {profileData?.userType == roles?.CLUB
                ? "🧢 Club/Academy Details"
                : "🧢 Venue Details"}
            </h2>
            {profileData?.userType == roles?.VENUE ? (
              <div>
                <div>Upload Venue Images</div>
                <div className="grid lg:grid-cols-8 md:grid-cols-6 grid-cols-3 my-3 gap-4">
                  {profileData?.venueImageUrl?.map((image, imageIndex) => (
                    <div
                      className="bg-gray-300 relative rounded-lg w-full h-24"
                      style={{
                        backgroundImage: `url("${image}")`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                      }}
                    >
                      <div className="absolute top-0 right-0">
                        <IoCloseCircleSharp
                          onClick={(value) => {
                            value.stopPropagation();
                            dispatch(
                              deleteProfileImage({
                                language: "en",
                                imageUrl: image,
                                type: 2,
                              })
                            );
                            let temp = { ...profileData };
                            temp.venueImageUrl = temp.venueImageUrl.filter(
                              (_, index) => index != imageIndex
                            );
                            temp.venueImageUrlPath =
                              temp.venueImageUrlPath.filter(
                                (_, index) => index != imageIndex
                              );

                            setProfileData(temp);
                          }}
                          className="h-6 w-6 cursor-pointer"
                          color="red"
                        />
                      </div>
                    </div>
                  ))}

                  {profileData?.venueImageUrl?.length < 5 && (
                    <div className="bg-gray-300 cursor-pointer flex justify-center items-center rounded-lg w-full h-24">
                      <input
                        ref={profileRef}
                        onChange={(e) => {
                          handleUploadProfile(e.target.files);
                        }}
                        multiple
                        style={{ display: "none" }}
                        type="file"
                        accept="image/*"
                      />
                      <FiPlus
                        onClick={() => {
                          profileRef.current?.click();
                        }}
                        className="h-16 w-16"
                        color="white"
                      />
                    </div>
                  )}
                </div>
              </div>
            ) : (
              ""
            )}
            {/* <div className="w-full md:h-40 h-32 rounded-xl flex flex-col items-center justify-center text-[#2bace2]  ">
              <div
                style={{
                  backgroundImage: `url("${
                    profileData?.venueImageUrl?.length > 0 &&
                    profileData?.venueImageUrl[0]
                  }")`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                }}
                className="relative md:w-32 md:h-32 w-24 h-24 border-2 border-[#2bace2] rounded-full  flex items-center justify-center mb-3"
              >
                <div className="cursor-pointer absolute md:bottom-2 bottom-0 w-8 h-8 flex items-center justify-center rounded-full bg-black right-0">
                  <MdEdit className="w-5 h-5" />
                </div>
              </div>
            </div> */}

            {profileData?.userType == roles?.CLUB ? (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Primary type */}
                <div className="">
                  <label className="block text-sm md:font-semibold font-medium text-gray-700 mb-1">
                    Primary type
                    <span className="text-red-500 ml-1 font-bold">*</span>
                  </label>
                  <div className="flex md:flex-row flex-col gap-3">
                    <label className="flex-1 relative cursor-pointer">
                      <input
                        type="radio"
                        onClick={() =>
                          handleChange("primaryType", PRIMARY_TYPE?.CLUB)
                        }
                        className="peer sr-only"
                        checked={PRIMARY_TYPE?.CLUB == profileData?.primaryType}
                      />
                      <p className="md:px-4 px-2 py-3 md:text-md text-sm border-2 border-gray-300 rounded-lg text-center peer-checked:border-[#2bace2] peer-checked:bg-[#2bace2]/5 peer-checked:text-[#2bace2] transition-all font-medium">
                        Club
                      </p>
                    </label>
                    <label className="flex-1 relative cursor-pointer">
                      <input
                        type="radio"
                        className="peer sr-only"
                        onClick={() =>
                          handleChange("primaryType", PRIMARY_TYPE?.ACADEMY)
                        }
                        checked={
                          PRIMARY_TYPE?.ACADEMY == profileData?.primaryType
                        }
                      />
                      <p className="md:px-4 px-2 py-3 md:text-md text-sm border-2 border-gray-300 rounded-lg text-center peer-checked:border-[#2bace2] peer-checked:bg-[#2bace2]/5 peer-checked:text-[#2bace2] transition-all font-medium">
                        Academy
                      </p>
                    </label>
                  </div>
                </div>

                {/* registered venue */}
                <div className="mb-4">
                  <label className="block text-sm md:font-semibold font-medium text-gray-700 mb-1">
                    Are you a registered venue?
                    <span className="text-red-500 ml-1 font-bold">*</span>
                  </label>
                  <div className="flex md:flex-row gap-3">
                    <label className="flex-1 relative cursor-pointer">
                      <input
                        type="radio"
                        onClick={() =>
                          handleChange(
                            profileData?.userType == roles?.CLUB
                              ? "areYouRegisteredClub"
                              : "areYouRegisteredVenue",
                            true
                          )
                        }
                        className="peer sr-only"
                        checked={
                          profileData?.userType == roles?.CLUB
                            ? profileData?.areYouRegisteredClub == true
                            : profileData?.areYouRegisteredVenue == true
                        }
                      />
                      <div className="md:px-4 px-2 py-3 md:text-md text-sm border-2 border-gray-300 rounded-lg text-center peer-checked:border-[#2bace2] peer-checked:bg-[#2bace2]/5 peer-checked:text-[#2bace2] transition-all font-medium">
                        Yes
                      </div>
                    </label>
                    <label className="flex-1 relative cursor-pointer">
                      <input
                        type="radio"
                        onClick={() =>
                          handleChange(
                            profileData?.userType == roles?.CLUB
                              ? "areYouRegisteredClub"
                              : "areYouRegisteredVenue",
                            false
                          )
                        }
                        className="peer sr-only"
                        checked={
                          profileData?.userType == roles?.CLUB
                            ? profileData?.areYouRegisteredClub == false
                            : profileData?.areYouRegisteredVenue == false
                        }
                      />
                      <div className="md:px-4 px-2 py-3 md:text-md text-sm border-2 border-gray-300 rounded-lg text-center peer-checked:border-[#2bace2] peer-checked:bg-[#2bace2]/5 peer-checked:text-[#2bace2] transition-all font-medium">
                        No
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            <Input
              label={
                profileData?.userType == roles?.VENUE
                  ? "Venue name"
                  : "Display Name"
              }
              onChange={(e) => handleChange("name", e)}
              isRequired
              value={profileData?.name}
            />

            {/* venue details */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* name */}
              {/* <Input
                label={
                  profileData?.userType == roles?.VENUE
                    ? "Venue name"
                    : "Display Name"
                }
                onChange={(e) => handleChange("name", e)}
                isRequired
                value={profileData?.name}
              /> */}

              {/* registration number */}
              {profileData?.areYouRegisteredVenue ||
                (profileData?.areYouRegisteredClub && (
                  <>
                    <div>
                      <div className="flex items-center justify-between mb-1">
                        <label className="block text-sm font-semibold text-gray-700 ">
                          Registration Number
                          <span className="text-red-500 ml-1 font-bold">*</span>
                        </label>
                        <span className="flex items-center text-sm font-semibold text-gray-700">
                          Hide from public &nbsp;
                          <Switch
                            checked={profileData?.registerNumberIsHide}
                            onChange={() =>
                              handleChange(
                                "emailIsHide",
                                !profileData?.registerNumberIsHide
                              )
                            }
                          />
                        </span>
                      </div>
                      <Input
                        onChange={(e) => handleChange("registeredVenueId", e)}
                        isRequired
                        value={profileData?.registeredVenueId}
                      />
                    </div>
                    {profileData?.userType == roles?.CLUB ? (
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 ">
                          Registered with
                        </label>
                        <Input
                          onChange={(e) => handleChange("registeredWith", e)}
                          isRequired
                          value={profileData?.registeredWith}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                ))}
              {/* venue type */}
              {profileData?.userType == roles?.VENUE ? (
                <>
                  {" "}
                  <div className="">
                    <label className="block text-sm md:font-semibold font-medium text-gray-700 mb-1">
                      Venue type
                      <span className="text-red-500 ml-1 font-bold">*</span>
                    </label>
                    <div className="flex md:flex-row flex-col gap-3">
                      <label className="flex-1 relative cursor-pointer">
                        <input
                          type="radio"
                          onClick={() =>
                            handleChange("venueType", VENUE_TYPE?.PRIVATE)
                          }
                          className="peer sr-only"
                          checked={
                            VENUE_TYPE?.PRIVATE == profileData?.venueType
                          }
                        />
                        <p className="md:px-4 px-2 py-3 md:text-md text-sm border-2 border-gray-300 rounded-lg text-center peer-checked:border-[#2bace2] peer-checked:bg-[#2bace2]/5 peer-checked:text-[#2bace2] transition-all font-medium">
                          Private Venue
                        </p>
                      </label>
                      <label className="flex-1 relative cursor-pointer">
                        <input
                          type="radio"
                          className="peer sr-only"
                          onClick={() =>
                            handleChange("venueType", VENUE_TYPE?.NORMAL)
                          }
                          checked={
                            VENUE_TYPE?.PUBLIC == profileData?.venueType ||
                            VENUE_TYPE?.NORMAL == profileData?.venueType
                          }
                        />
                        <p className="md:px-4 px-2 py-3 md:text-md text-sm border-2 border-gray-300 rounded-lg text-center peer-checked:border-[#2bace2] peer-checked:bg-[#2bace2]/5 peer-checked:text-[#2bace2] transition-all font-medium">
                          Public Venue
                        </p>
                      </label>
                    </div>
                  </div>
                  <SelectField
                    label="Venue Style"
                    id="game"
                    value={profileData?.venueStyle}
                    onChange={(value) => handleChange("venueStyle", value)}
                    options={gameTypeOption}
                    placeholder="Select venue style"
                  />
                </>
              ) : (
                ""
              )}
            </div>

            {/* contact info */}
            <div>
              <h2 className="md:text-xl text-lg  font-semibold text-gray-800 flex items-center gap-2 md:my-5 my-4">
                <div className="w-1 h-6 bg-[#2bace2] rounded-full"></div>
                ☎️ Contact Information
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* email  */}
                <div>
                  <div className="flex items-center justify-between mb-1">
                    <label className="block text-sm font-semibold text-gray-700 ">
                      Sign-up Email ID{" "}
                      <span className="text-red-500 ml-1 font-bold">*</span>
                    </label>
                    <span className="flex items-center text-sm font-semibold text-gray-700">
                      Hide Email &nbsp;
                      <Switch
                        checked={profileData?.emailIsHide}
                        onChange={() =>
                          handleChange("emailIsHide", !profileData?.emailIsHide)
                        }
                      />
                    </span>
                  </div>
                  <Input disabled isRequired value={profileData?.email} />
                </div>
                {/* contact number */}
                <div>
                  <div className="flex justify-between items-center mb-1">
                    <label className="block text-sm font-semibold text-gray-700 ">
                      Phone number{" "}
                      <span className="text-red-500 ml-1 font-bold">*</span>
                    </label>
                    <span className="flex items-center text-sm font-semibold text-gray-700">
                      Hide Contact &nbsp;
                      <Switch
                        checked={profileData?.contactIsHide}
                        onChange={() =>
                          handleChange(
                            "contactIsHide",
                            !profileData?.contactIsHide
                          )
                        }
                      />
                    </span>
                  </div>
                  <div style={{ marginTop: "-0.4rem" }}>
                    <PhoneNumber
                      placeholder="Phone number"
                      phone={`${profileData?.countryCode + profileData?.contactNo
                        }`}
                      handlePhoneChange={(val, inputdata) => {
                        handleChange(
                          "contactNo",
                          val.slice(inputdata?.country?.dialCode?.length + 1)
                        );
                        handleChange(
                          "countryCode",
                          `+${inputdata?.country?.dialCode}`
                        );
                      }}
                    // error={formData?.phoneError}
                    />
                  </div>
                </div>

                {/* email optional  */}
                <div className="md:col-span-2">
                  <label className="block text-sm font-semibold text-gray-700 ">
                    Contact Email(optional)
                  </label>
                  {profileData?.alternativeEmail?.map((email, index) => (
                    <div className="flex items-center mt-3">
                      <Input
                        className=" w-full"
                        key={index}
                        value={email}
                        onChange={(value) => {
                          let temp = { ...profileData };
                          temp.alternativeEmail[index] = value;
                          setProfileData(temp);
                        }}
                        placeholder="Enter email"
                      />
                      {index != 0 && (
                        <>
                          &nbsp;&nbsp;
                          <Trash2
                            onClick={(value) => {
                              let temp = { ...profileData };
                              temp.alternativeEmail =
                                temp.alternativeEmail.filter(
                                  (_, i) => i !== index
                                );

                              setProfileData(temp);
                            }}
                            className="text-red-500 cursor-pointer"
                            size={25}
                          />
                        </>
                      )}
                    </div>
                  ))}
                  {profileData?.alternativeEmail?.length < 3 && (
                    <p
                      onClick={() => {
                        let temp = { ...profileData };
                        temp.alternativeEmail.push("");
                        setProfileData(temp);
                      }}
                      className="flex mt-1 font-semibold justify-end w-full text-md text-[#2bace2] cursor-pointer"
                    >
                      + Add More
                    </p>
                  )}
                </div>

                {/* contact number */}
                <div className="md:col-span-2">
                  <label className="block text-sm font-semibold text-gray-700 ">
                    Contact Number(optional)
                  </label>
                  {profileData?.alternativeNumber?.map((conatct, index) => (
                    <div className="flex items-center mt-2">
                      <PhoneNumber
                        className="w-full"
                        placeholder="Contact number (optional)"
                        phone={`${conatct?.countryCode + conatct?.contactNo}`}
                        handlePhoneChange={(val, inputdata) => {
                          let temp = { ...profileData };
                          temp.alternativeNumber[
                            index
                          ].countryCode = `+${inputdata?.country?.dialCode}`;
                          temp.alternativeNumber[index].contactNo = val.slice(
                            inputdata?.country?.dialCode?.length + 1
                          );
                          setProfileData(temp);
                        }}
                      />
                      {index != 0 && (
                        <>
                          &nbsp;&nbsp;
                          <Trash2
                            onClick={(value) => {
                              let temp = { ...profileData };
                              temp.alternativeNumber =
                                temp.alternativeNumber.filter(
                                  (_, i) => i !== index
                                );

                              setProfileData(temp);
                            }}
                            className="text-red-500 cursor-pointer mt-2"
                            size={25}
                          />
                        </>
                      )}
                    </div>
                  ))}

                  {profileData?.alternativeNumber?.length < 2 && (
                    <p
                      onClick={() => {
                        let temp = { ...profileData };
                        temp.alternativeNumber.push({
                          contactNo: "",
                          countryCode: "",
                        });
                        setProfileData(temp);
                      }}
                      className="flex mt-1 font-semibold justify-end w-full text-md text-[#2bace2] cursor-pointer"
                    >
                      + Add More
                    </p>
                  )}
                </div>

                {/* Location */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 ">
                    {profileData?.userType == roles?.VENUE
                      ? "Venue Location"
                      : "Location/Address"}
                    <span className="text-red-500 ml-1 font-bold">*</span>
                  </label>
                  <div className="pt-1">
                    <LocationPicker
                      onChange={(place) => {
                        const obj = {
                          address: place?.formatted_address,
                          coordinates: [
                            place?.geometry?.location?.lng(),
                            place?.geometry?.location?.lat(),
                          ],
                        };
                        setProfileData((prev) => ({
                          ...prev,
                          location: obj,
                        }));
                      }}
                      value={profileData?.location?.address}
                      placeholder={"search an address"}
                    />
                  </div>
                </div>

                {/* website */}
                <Input
                  label={
                    profileData?.userType == roles?.VENUE
                      ? "Official Website"
                      : "Official Website (URL)"
                  }
                  placeholder="Copy-Paste your company website url here"
                  onChange={(e) => handleChange("webSiteUrl", e)}
                  value={profileData?.webSiteUrl}
                />
              </div>
            </div>

            {/* Socials */}
            <div style={{ marginTop: "2rem" }} className="md:col-span-2">
              <label className="block text-sm font-semibold text-gray-700 ">
                Socials(optional)
              </label>
              {profileData?.socialLink?.map((conatct, index) => (
                <div className="flex items-center mt-2">
                  <Input
                    label=""
                    placeholder="Put URL Instragram/Facebook/YouTube/Link..."
                    onChange={(val) => {
                      let temp = { ...profileData };
                      temp.socialLink[index] = val;
                      setProfileData(temp);
                    }}
                    value={profileData?.socialLink[index]}
                  />
                  {index != 0 && (
                    <>
                      &nbsp;&nbsp;
                      <Trash2
                        onClick={(value) => {
                          let temp = { ...profileData };
                          temp.socialLink = temp.socialLink.filter(
                            (_, i) => i !== index
                          );

                          setProfileData(temp);
                        }}
                        className="text-red-500 cursor-pointer mt-2"
                        size={25}
                      />
                    </>
                  )}
                </div>
              ))}

              {profileData?.socialLink?.length < 3 && (
                <p
                  onClick={() => {
                    let temp = { ...profileData };
                    temp.socialLink.push("");
                    setProfileData(temp);
                  }}
                  className="flex mt-1 font-semibold justify-end w-full text-md text-[#2bace2] cursor-pointer"
                >
                  + Add More
                </p>
              )}
            </div>

            <div>
              <h2 className="md:text-xl text-lg  font-semibold text-gray-800 flex items-center gap-2 md:my-5 my-4">
                <div className="w-1 h-6 bg-[#2bace2] rounded-full"></div>
                🏏{" "}
                {profileData?.userType == roles?.VENUE
                  ? "Venue"
                  : "Club/Academy"}{" "}
                Specifics
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Primary Sports / Games{" "}
                    {profileData?.userType == roles?.VENUE ? "Catered" : ""}
                    <span className="text-red-500 ml-1">*</span>
                  </label>

                  <MultiSelectWrapper
                    id="sport-group"
                    isSportsList
                    isSearch
                    options={venueSelectedSportsData}
                    value={profileData?.primarySports}
                    onChange={(value) => {
                      console.log("value", value);
                      setProfileData((profileData) => ({
                        ...profileData,
                        primarySports: value,
                      }));
                    }}
                    placeholder="Select sports"
                    error=""
                    isRequired
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Additional Sports / Games{" "}
                    {profileData?.userType == roles?.VENUE ? "Catered" : ""}
                  </label>

                  <MultiSelectWrapper
                    id="sport-group"
                    isSportsList
                    isSearch
                    options={venueSelectedSportsData || []}
                    value={profileData?.multirepresentingGames}
                    onChange={(value) => {
                      setProfileData((profileData) => ({
                        ...profileData,
                        multirepresentingGames: value,
                      }));
                    }}
                    placeholder="Select sports"
                    error=""
                  />
                </div>

                {/*   Age Group Catered */}
                <div>
                  <label className="block text-sm md:font-semibold font-medium text-gray-700 mb-1">
                    Age Group Catered{" "}
                    <span className="text-red-500 ml-1 font-bold">*</span>
                  </label>

                  <MultiSelectWrapper
                    id="age-group"
                    options={configData?.ageGroup}
                    value={profileData?.multiAgeGroup}
                    onChange={(value) => {
                      setProfileData((profileData) => ({
                        ...profileData,
                        multiAgeGroup: value,
                      }));
                    }}
                    placeholder="Select Age Group"
                    error=""
                  />
                </div>
                <div>
                  <label className="block text-sm md:font-semibold font-medium text-gray-700 mb-1">
                    Gender Catered{" "}
                    <span className="text-red-500 ml-1 font-bold">*</span>
                  </label>
                  <MultiSelectWrapper
                    label="Gender Catered"
                    value={profileData?.genderServing}
                    onChange={(value) => {
                      console.log("value", value);
                      if (value?.some((item) => item === "All Genders")) {
                        setProfileData((profileData) => ({
                          ...profileData,
                          genderServing: genderOptions?.map((item) => item?.id),
                        }));
                      } else {
                        setProfileData((profileData) => ({
                          ...profileData,
                          genderServing: value,
                        }));
                      }
                    }}
                    options={genderOptions}
                    placeholder="Select gender"
                  />{" "}
                </div>
                <div>
                  <label className="block text-sm md:font-semibold font-medium text-gray-700 mb-1">
                    Associated Venue (if any)
                  </label>
                  <AutocompleteInput
                    inputClass="!w-full"
                    handleChange={onSportSearch}
                    filteredSuggestions={vanueList}
                    handleSelectSuggestion={(e) => {
                      handleChange("associatedVenueAndClub", e.id);
                      handleChange("associatedVenueAndClubName", e.name);
                    }}
                    value={profileData?.associatedVenueAndClubName}
                  />
                </div>
              </div>
            </div>

            {/* Amenities */}
            {profileData?.userType == roles?.VENUE &&
              profileData?.venueAmenities?.map((item, index) => {
                return (
                  <div key={item?.name} className="w-full mt-8">
                    <h2 className="md:text-xl text-lg md:font-bold font-semibold text-gray-800 flex items-center gap-2 md:my-5 my-4">
                      <div className="w-1 h-6 bg-[#2bace2] rounded-full"></div>
                      {item?.name == "Accessibility" && "♿"}
                      {item?.name == "Amenities" && "🏢"}
                      {item?.name == "Toilets" && "🚻"}
                      {item?.name == "Access" && "🚪"} {item?.name}
                    </h2>
                    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
                      {item?.items?.map((amenity, subIndex) => (
                        <button
                          key={amenity.key}
                          onClick={() => {
                            let temp = [
                              ...JSON.parse(
                                JSON.stringify(profileData?.venueAmenities)
                              ),
                            ];
                            temp[index].items[subIndex].isSelected =
                              !amenity?.isSelected;
                            setProfileData((prev) => ({
                              ...prev,
                              venueAmenities: temp,
                            }));
                          }}
                          className={`p-2 rounded-xl border-2 transition-all ${amenity?.isSelected
                            ? "border-[#2bace2] bg-[#2bace2]/10 text-[#2bace2]"
                            : "border-gray-200 hover:border-[#2bace2]/50 hover:bg-gray-50"
                            }`}
                        >
                          <div className="flex flex-col items-center gap-2">
                            <div
                              className={`rounded-full flex items-center justify-center `}
                            >
                              <div className="rounded-sm flex items-center justify-center">
                                <img
                                  src={amenity?.url}
                                  alt=""
                                  className="w-8 h-8"
                                  style={{
                                    filter: amenity?.isSelected
                                      ? "brightness(0) saturate(100%) invert(52%) sepia(88%) saturate(437%) hue-rotate(167deg) brightness(95%) contrast(95%)"
                                      : "brightness(0.5)",
                                  }}
                                />
                              </div>
                            </div>
                            <span className="text-sm font-medium">
                              {amenity?.name}
                            </span>
                          </div>
                        </button>
                      ))}
                    </div>
                  </div>
                );
              })}

            <h2 className="md:text-xl text-lg md:font-bold font-semibold text-gray-800 flex items-center gap-2 md:my-5 my-4">
              <div className="w-1 h-6 bg-[#2bace2] rounded-full"></div>
              📖 Portfolio
            </h2>
            {/* bio */}
            <div className="md:col-span-2">
              <label className="block text-sm md:font-semibold font-medium text-gray-700 mb-1">
                Bio/Portfolio
              </label>
              <textarea
                placeholder="Enter bio/portfolio"
                rows="5"
                onChange={(e) => handleChange("portfolio", e.target.value)}
                value={profileData?.portfolio}
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl shadow-sm focus:border-[#2bace2] transition-all outline-none resize-none"
              />
            </div>

            <h2 className="md:text-xl text-lg md:font-bold font-semibold text-gray-800 flex items-center gap-2 md:my-5 my-4">
              <div className="w-1 h-6 bg-[#2bace2] rounded-full"></div>
              👥 Key Members
            </h2>
            <KeyMembers
              handleSubmit={handleSubmit}
              profileData={profileData}
              keyMember_initital_state={keyMember_initital_state}
              setProfileData={setProfileData}
              achievement_initital_state={achievement_initital_state}
            />
          </div>
        </div>
      </div>
      {selectedPlayer && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden animate-fadeIn">
            {/* Header */}
            <div className="bg-gradient-to-r from-[#2BACE2] to-[#1a8ec4] px-6 py-4 flex items-center justify-between">
              <h3 className="text-lg font-semibold text-white">
                Player Details
              </h3>
              <button
                onClick={() => setSelectedPlayer(null)}
                className="text-white text-xl hover:opacity-80"
              >
                ✕
              </button>
            </div>

            {/* Content */}
            <div className="p-6 space-y-6 md:h-auto h-96 overflow-y-auto">
              {/* Player identity */}
              <div className="flex md:flex-row flex-col justify-between md:items-center md:gap-0 gap-2">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#2BACE2] to-[#1a8ec4] text-white flex items-center justify-center text-xl font-bold shadow-md shrink-0">
                    {selectedPlayer.initial}
                  </div>

                  <div className="">
                    <p
                      className="text-lg font-semibold text-gray-800 truncate max-w-[220px]"
                      title={selectedPlayer.name}
                    >
                      {selectedPlayer.name}
                    </p>
                    <p className="text-sm text-gray-500">
                      {selectedPlayer.sportName}
                    </p>
                  </div>
                </div>

                <div className="md:w-auto w-full flex justify-end">
                  <Button className="w-fit">View Profile</Button>
                </div>
              </div>

              {/* Details */}
              <div className="space-y-3 text-sm">
                <div className="flex justify-between gap-3 pb-2 border-b">
                  <span className="font-medium text-gray-500">Player ID</span>
                  <span
                    className="text-gray-800 max-w-[250px] truncate text-right"
                    title={selectedPlayer.id}
                  >
                    {selectedPlayer.id}
                  </span>
                </div>

                <div className="flex justify-between gap-3 pb-2 border-b">
                  <span className="font-medium text-gray-500">
                    Game / Sport
                  </span>
                  <span className="text-gray-800 text-right">
                    {selectedPlayer.sportName}
                  </span>
                </div>

                <div className="flex justify-between gap-3 pb-2 border-b">
                  <span className="font-medium text-gray-500">Skill Level</span>
                  <span className="text-gray-800 text-right">
                    {selectedPlayer.skillLevel}
                  </span>
                </div>

                <div className="flex justify-between gap-3 pb-2 border-b">
                  <span className="font-medium text-gray-500">
                    Achievements
                  </span>
                  <span
                    className="text-gray-800 text-right max-w-[250px] line-clamp-2"
                    title={selectedPlayer.achievement}
                  >
                    {selectedPlayer.achievement}
                  </span>
                </div>

                <div className="flex justify-between gap-3 pb-2 border-b">
                  <span className="font-medium text-gray-500">Location</span>
                  <Link
                    className="text-highlight underline max-w-[250px] line-clamp-2 text-right"
                    title={selectedPlayer.location}
                  >
                    {selectedPlayer.location || "N/A"}
                  </Link>
                </div>

                <div className="flex justify-between gap-3">
                  <span className="font-medium text-gray-500">Description</span>
                  <span
                    className="text-gray-800 text-right max-w-[250px] line-clamp-2"
                    title={selectedPlayer.description}
                  >
                    {selectedPlayer.achievement}
                  </span>
                </div>
              </div>
              <div className="flex justify-center">
                <Button>Send request</Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileEdit;
